import api from "./base";

/**
 * Fetches settings for the current user.
 *
 * @returns {Promise<Object>} Resolves to an object with the following structure:
 * {
 *   user: { ... }, // user info
 *   modals: Array,
 *   banners: Array,
 *   teacher: { ... }, // teacher info
 *   latestAgreementVersion: string
 * }
 *
 * Example user/teacher structure is provided in the documentation.
 */
export async function fetchSettings() {
    const res = await api.get("/settings");
    return res.data;
} 